import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MyModulesEffects } from './my-modules.effects';
import * as fromMyModules from './my-modules.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, EffectsModule.forFeature([MyModulesEffects]), StoreModule.forFeature(fromMyModules.myModulesFeatureKey, fromMyModules.reducer)],
})
export class MyModulesStoreModule {}
